<template>
  <div>
    <b-spinner small label="กำลังโหลด" variant="secondary" class="mr-2" /><span class="text-muted">กำลังโหลด{{ thing }}</span>
  </div>
</template>

<script>
export default {
  props: {
    thing: { type: String, required: false, default: '' }
  }
}
</script>
